// Vimeo and Youtube iframe //
document.addEventListener('DOMContentLoaded', () => {
  // Function to handle video embedding
  function initializeVideoPlayer({
    platform,
    videoElement,
    videoId,
    videoIdMobile,
    embedContainer,
    playBtn,
    closeBtn,
  }) {
    let player;

    playBtn.addEventListener('click', function () {
      const iframe = document.createElement('iframe');
      const isMobile = window.innerWidth < 1024;
      const videoSrc =
        platform === 'youtube'
          ? `https://www.youtube.com/embed/${isMobile && videoIdMobile ? videoIdMobile : videoId}?enablejsapi=1&autoplay=1&mute=0&controls=1`
          : `https://player.vimeo.com/video/${isMobile && videoIdMobile ? videoIdMobile : videoId}?autoplay=1&muted=0&controls=1&title=0&byline=0&portrait=0&background=0&loop=0&autopause=0`;

      iframe.setAttribute('src', videoSrc);
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      );
      iframe.setAttribute('id', 'video-player');
      iframe.setAttribute('class', 'absolute top-0 left-0 w-full h-full video');

      embedContainer.innerHTML = ''; // Clear existing content
      embedContainer.appendChild(iframe);

      // Neither the YouTube IFrame API nor the Vimeo Player API is loaded by this theme, so `YT`
      // and `Vimeo` are normally undefined. These calls used to run unguarded and threw an
      // uncaught ReferenceError on every play click — the iframe is appended above and autoplays
      // from its own src parameters, so the video still played and the error went unnoticed.
      //
      // `typeof` is required: a bare `YT` reference throws rather than evaluating falsy. The blocks
      // are kept rather than deleted so a project that does load either API gets programmatic
      // control for free. Closing works either way — clearing embedContainer removes the iframe.
      if (platform === 'youtube' && typeof YT !== 'undefined' && YT.Player) {
        player = new YT.Player(iframe, {
          events: {},
        });
      } else if (platform === 'vimeo' && typeof Vimeo !== 'undefined' && Vimeo.Player) {
        player = new Vimeo.Player(iframe);
        player.play();
      }
    });

    closeBtn.addEventListener('click', function () {
      if (player) {
        if (platform === 'youtube' && typeof player.stopVideo === 'function') {
          player.stopVideo(); // Stop YouTube video
        } else if (platform === 'vimeo' && typeof player.pause === 'function') {
          player.pause(); // Pause Vimeo video
        }
      }
      embedContainer.innerHTML = ''; // Clear the iframe
    });
  }

  // Initialize Vimeo players
  document.querySelectorAll('[class*=cms-vimeo]').forEach(function (vimeo_vid) {
    const videoText = vimeo_vid.closest('[id^="data-video-"]');
    const embedContainer = vimeo_vid.querySelector('#embed-video');

    // The wrapper and the embed container both have to exist before anything can be wired up.
    if (!videoText || !embedContainer) return;

    const videoId = embedContainer.getAttribute('data-id');
    const videoIdMobile = embedContainer.getAttribute('data-id-mobile');

    // [data-video-play] is the visible trigger in blocks/_utility-media.liquid. The legacy
    // '#playbtn-cms' lookup is kept as a fallback for markup that has not been updated, but it
    // must not win: the button of that id inside utility-embed-video.liquid sits within the
    // lightbox and is hidden whenever the lightbox is open.
    const playBtn = videoText.querySelector('[data-video-play]') || videoText.querySelector('#playbtn-cms');
    const closeBtn = videoText.querySelector('.close');

    if (!playBtn || !closeBtn) return;

    initializeVideoPlayer({
      platform: 'vimeo',
      videoElement: vimeo_vid,
      videoId,
      videoIdMobile,
      embedContainer,
      playBtn,
      closeBtn,
    });
  });

  // Initialize YouTube players
  document.querySelectorAll('[class*=cms-youtube]').forEach(function (yt_vid) {
    const videoText = yt_vid.closest('[id^="data-video-"]');
    const embedContainer = yt_vid.querySelector('#embed-video');

    // The wrapper and the embed container both have to exist before anything can be wired up.
    if (!videoText || !embedContainer) return;

    const videoId = embedContainer.getAttribute('data-id');
    const videoIdMobile = embedContainer.getAttribute('data-id-mobile');

    // [data-video-play] is the visible trigger in blocks/_utility-media.liquid. The legacy
    // '#playbtn-cms' lookup is kept as a fallback for markup that has not been updated, but it
    // must not win: the button of that id inside utility-embed-video.liquid sits within the
    // lightbox and is hidden whenever the lightbox is open.
    const playBtn = videoText.querySelector('[data-video-play]') || videoText.querySelector('#playbtn-cms');
    const closeBtn = videoText.querySelector('.close');

    if (!playBtn || !closeBtn) return;

    initializeVideoPlayer({
      platform: 'youtube',
      videoElement: yt_vid,
      videoId,
      videoIdMobile,
      embedContainer,
      playBtn,
      closeBtn,
    });
  });
});